'use client'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import Image from 'next/image'

function ClientsPartnersSection() {
   const router = useRouter()

   // Function to handle client logo click
   const handleClientClick = (path) => {
      if (path) {
         router.push(path)
      }
   }

   return (
      <section className="section_secondary_bg">
         <div className="container">
            <div className="mb-5">
               <h2 className="tech_title section_heading_title m-0">
                  Working With the Best Clients and Partners
               </h2>
               <div className="">
                  <p className="section_desc partners-desc">
                     From an early stage start-up's growth strategies to helping
                     existing businesses, we have done it all! The results speak
                     for themselves. Our services work.
                  </p>
               </div>
            </div>

            <Swiper
               modules={[Navigation, Pagination, Autoplay]}
               autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
               }}
               slidesPerView={1}
               grabCursor={true}
               spaceBetween={30}
               freeMode={false}
               loop={true}
               keyboard={{ enabled: true }}
               speed={600}
               navigation={{
                  nextEl: '.custom-clients-wrap-next-btn',
                  prevEl: '.custom-clients-wrap-prev-btn',
               }}
               breakpoints={{
                  768: {
                     slidesPerView: 2,
                     spaceBetween: 30,
                  },
                  992: {
                     slidesPerView: 2,
                     spaceBetween: -50,
                  },
                  1200: {
                     slidesPerView: 3,
                     spaceBetween: 85,
                  },
                  1440: {
                     slidesPerView: 3,
                     spaceBetween: 10,
                  },
               }}
               className="custom-clients_slider"
            >
               <SwiperSlide>
                  <Link
                     href={'/portfolio/magic-shoes'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <Image
                        height={95}
                        width={160}
                        src="/assets/svg/home/magic-shoes.svg"
                        alt="magic-shoes"
                        className="magic-shoes-slider-img"
                     />
                  </Link>
               </SwiperSlide>
               {/* <SwiperSlide>
                  <Link
                     href={'/portfolio/case-studies/robotmaker-ai'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <Image
                        height={78}
                        width={250}
                        src="/assets/svg/home/robot-maker.svg"
                        alt="robot-maker"
                        className="robot-maker-slider-img"
                     />
                  </Link>
               </SwiperSlide> */}
               <SwiperSlide>
                  <div className="clients-logo-wrap">
                     <Image
                        height={100}
                        width={230}
                        src="/assets/svg/home/eg.svg"
                        alt="eg"
                        className="eg-slider-img"
                     />
                  </div>
               </SwiperSlide>
               <SwiperSlide>
                  <Link
                     href={'/portfolio/case-studies/care-boarding'}
                     className="clients-logo-wrap"
                     style={{ cursor: 'pointer' }}
                  >
                     <Image
                        height={60}
                        width={270}
                        src="/assets/svg/home/new-careboarding.svg"
                        alt="care-boarding"
                        className="care-boarding-slider-img"
                     />
                  </Link>
               </SwiperSlide>

               <div className="d-flex justify-content-center mt-4">
                  <button className="custom-clients-wrap-prev-btn">
                     <Image
                        height={45}
                        width={45}
                        src="/assets/svg/technologies/down-arrow.svg"
                        alt="prev"
                     />
                  </button>

                  <button className="custom-clients-wrap-next-btn">
                     <Image
                        height={45}
                        width={45}
                        src="/assets/svg/technologies/down-arrow.svg"
                        alt="next"
                     />
                  </button>
               </div>
            </Swiper>

            {/*  */}
         </div>
      </section>
   )
}

export default ClientsPartnersSection
